// extracted by mini-css-extract-plugin
export default {"banner":"P7jtJw","mobile":"evAD1E","wrapper":"NiOs7j","separator":"zMOl1w","text-wrapper":"C3PFSt","link-wrapper":"lISoMN"};